export const setProfileData = (data) => {
  return {
    type: "SETUSERDETAILS",
    payload: data,
  };
};
  export const setUserToken = (data) => {
   return {
    type: "SETUSERTOKEN",
    payload: data,
  };
};
